import { render, staticRenderFns } from "./goldDetail.vue?vue&type=template&id=95a41694&scoped=true"
import script from "./goldDetail.vue?vue&type=script&lang=js"
export * from "./goldDetail.vue?vue&type=script&lang=js"
import style0 from "./goldDetail.vue?vue&type=style&index=0&id=95a41694&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a41694",
  null
  
)

export default component.exports